import './App.css';

import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Applications from './comp/dashboard/DashboardContainer'
import Dashboard from './comp/dashboard/DashboardContainer';
import Login from './comp/rest/loginContainer'
import Prompt from 'common/form/Prompt'
import Wrapper from './comp/rest/wrapper/WrapperContainer';

const Waas = (props) => {        
    return (
        <Wrapper {...props}>
            <Switch>
                <Route exact path="/" component={props => <Dashboard {...props} />} />
                <Route path="/applications/:id" component={props => <Applications {...props} />} />
                {/* <Route path='/applications' component={DashboardTable} /> */}
                <Route path='/demo-user/' component={() => { window.location.href = 'https://api.waas.barracudanetworks.com/demo-user-waas/'; return null; }} />
                {/* <Route component={DashboardTable} /> */}
            </Switch>
            <Prompt />
        </Wrapper>
    );
};


class App extends Component {
    render() {
        return (
            <Switch>
                <Route exact path="/" component={props => <Waas {...props} />} />
                <Route path="/login" component={props => <Login {...props} />} />
                <Route path="/bcc_login" component={props => <Login {...props} />} />
                <Route path="/403" component={props => <Login {...props} />} />
                <Route component={props => <Waas {...props} />} />
            </Switch>
        );
    }
}

export default App;
